//----- Component --------------------------------------------------------/
// Developer :  Nicolas Pascucci
// Creation Date : 11/02/2025
// Version : 1
// Description : Detalle de los datos del empleado
import { Grid, TextField, Container } from "@mui/material";

function DetalleEmpleado(props) {
  const { row } = props;

  //Si en un futuro se tienen que agregar talles nuevos solo agreguenlos con el mismo formato a el array talles ;p
  const talles = [
    { prenda: "Pantalon", talle: row.talle_pantalon },
    { prenda: "Remera", talle: row.talle_remera },
    { prenda: "Buzo", talle: row.talle_buzo },
    { prenda: "Botin", talle: row.talle_botin },
    { prenda: "Faja", talle: row.talle_faja },
    { prenda: "Campera", talle: row.talle_campera },
  ];

  console.log("ROW:", row);

  return (
    <Container maxWidth="lg" sx={{ width: "200%", padding: 2 }}>
      <Grid container spacing={2} justifyContent="center">
        {talles.map((t) => (
          <Grid item xs={4}>
            <TextField
              fullWidth
              label={`Talle de ${t.prenda}`}
              name={`Talle de ${t.prenda}`}
              variant="filled"
              size="small"
              focused
              value={t.talle ?? "Sin especificar"}
              InputProps={{
                readOnly: true,
              }}
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "#f5f5f5",
                },
                "& .Mui-focused": {
                  backgroundColor: "#e0e0e0",
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default DetalleEmpleado;
